import React, { useContext } from 'react';
import { motion } from 'framer-motion';
import { 
  ShoppingBagIcon, 
  VideoCameraIcon,
  BuildingStorefrontIcon,
  ChartBarIcon
} from '@heroicons/react/24/outline';
import { LanguageContext } from '../contexts/LanguageContext';
import { translations } from '../locales/translations';

const Solutions = () => {
  const { language } = useContext(LanguageContext);
  const t = translations[language].solutionsPage;

  const iconMap = {
    amazon: ShoppingBagIcon,
    tiktok: VideoCameraIcon,
    'multi-channel': BuildingStorefrontIcon
  };

  return (
    <div className="min-h-screen pt-16">
      {/* 解决方案概览 */}
      <section className="bg-gray-50 py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center mb-16"
          >
            <h1 className="text-4xl font-bold text-gray-900 mb-4">
              {t.hero.title}
            </h1>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              {t.hero.subtitle}
            </p>
          </motion.div>

          {/* 解决方案详情 */}
          {t.solutions.map((solution, index) => (
            <motion.div
              key={solution.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.2 }}
              viewport={{ once: true }}
              className="bg-white rounded-2xl shadow-xl p-8 mb-8"
            >
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 bg-primary rounded-lg flex items-center justify-center mr-4">
                  {iconMap[solution.id] && React.createElement(iconMap[solution.id], {
                    className: "w-6 h-6 text-white"
                  })}
                </div>
                <div>
                  <h2 className="text-2xl font-bold text-gray-900">{solution.title}</h2>
                  <p className="text-gray-600">{solution.description}</p>
                </div>
              </div>

              <div className="grid md:grid-cols-2 gap-8">
                {/* 痛点分析 */}
                <div className="space-y-4">
                  <h3 className="text-xl font-semibold text-gray-900 mb-4">
                    {language === 'en' ? 'Key Pain Points' : '主要痛点'}
                  </h3>
                  <ul className="space-y-2">
                    {solution.painPoints.map((point, idx) => (
                      <li key={idx} className="flex items-center text-gray-600">
                        <div className="w-2 h-2 bg-red-500 rounded-full mr-2"></div>
                        {point}
                      </li>
                    ))}
                  </ul>
                </div>

                {/* 解决方案特点 */}
                <div className="space-y-6">
                  {solution.features.map((feature, idx) => (
                    <div key={idx} className="space-y-2">
                      <h4 className="text-lg font-semibold text-gray-900">
                        {feature.title}
                      </h4>
                      <p className="text-gray-600">{feature.description}</p>
                    </div>
                  ))}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </section>

      {/* 咨询部分 */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            {t.consultation.title}
          </h2>
          <p className="text-xl text-gray-600 mb-8">
            {t.consultation.subtitle}
          </p>
          <button className="bg-primary text-white px-8 py-3 rounded-lg font-medium hover:bg-blue-600 transition-colors">
            {t.consultation.button}
          </button>
        </div>
      </section>
    </div>
  );
};

export default Solutions;